export const formatStorageValueFromMB = (valueInMB: number): string => {
    if (!valueInMB || valueInMB === 0) {
        return "0 MB";
    }

    const units = ['MB', 'GB', 'TB', 'PB'];
    const unitSize = 1024;
    let convertedValue = valueInMB;
    let unitIndex = 0;

    while (convertedValue >= unitSize && unitIndex < units.length - 1) {
        convertedValue /= unitSize;
        unitIndex++;
    }

    return `${convertedValue.toFixed(2)} ${units[unitIndex]}`;
};